module.exports = __webpack_public_path__ + "icon-sms-lake.1e1c9a8ad3c1ad3d667e.svg";